import { QueryClient } from '@tanstack/react-query';

// Per plan §9 decision #2: TanStack Query is the single server-state store.
// Default options chosen for Pirouette's workload:
//   - studio data changes infrequently → 60s staleTime
//   - retry network blips once → reduce false errors on flaky parent wifi
//   - background refetch on focus → fresh attendance / messages on tab return

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      gcTime: 5 * 60_000,
      retry: 1,
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
    },
    mutations: {
      retry: 0,
    },
  },
});

// Conventional query-key namespaces. Each data hook puts its key under
// one of these so invalidations are scoped, not global.
export const queryKeys = {
  families: ['families'] as const,
  dancers: (familyId?: string) =>
    familyId ? (['dancers', familyId] as const) : (['dancers'] as const),
  classes: ['classes'] as const,
  enrollments: (dancerId?: string) =>
    dancerId ? (['enrollments', dancerId] as const) : (['enrollments'] as const),
  attendance: (classId: string) => ['attendance', classId] as const,
  productions: ['productions'] as const,
  charges: (familyId: string) => ['charges', familyId] as const,
  audit: ['audit'] as const,
};
